import React, { useEffect } from 'react';

import useAuth from '../hooks/useAuth';
import useImage from '../hooks/useImage';
import NumberingContent from '../components/NumberingContent';
import AppQr from '../components/AppQr';

/**
 * @description 인증 QR 코드를 보여주는 Main 페이지
 */
function AuthPage() {
  // Auth Redux사용
  const { auth } = useAuth();
  // Image Redux사용
  const { image, check, onKiasBar } = useImage();

  // 고해상도 이미지 랜더링
  useEffect(() => {
    if (!check(image.kisa_bar)) onKiasBar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="auth-page container">
      <div className="wrapper">
        <div className="auth-service-title">
          <p className="text-title">
            <strong className="text-title-large">{auth.title}</strong>의
          </p>
          <p className="text-title">인증 요청이 있습니다.</p>
        </div>
        <div className="auth-content">
          <NumberingContent
            number={1}
            title="MetaPass 모바일사원증의"
            title_bold='"그룹웨어 인증" 버튼 선택'
          >
            <img src={image.kisa_bar} alt="Application top bar" />
          </NumberingContent>
          <NumberingContent number={2} title="하단의" title_bold="QR코드 스캔">
            <AppQr scheme_uri={auth.scheme_uri} limit_itme={auth.limit_time} />
          </NumberingContent>
        </div>
      </div>
    </div>
  );
}

export default AuthPage;
